import { useState } from 'react';
import { PricingTabs } from './components/PricingTabs.jsx';
import { RulesList } from './components/rules/RulesList.jsx';
import { PackagesList } from './components/packages/PackagesList.jsx';
import { DiscountsList } from './components/discounts/DiscountsList.jsx';
import { Simulator } from './components/simulator/Simulator.jsx';
// نفس مكوّن إدارة باقات الاشتراك المستعمل في شاشة الاشتراكات — مصدر واحد
// للواجهة، فلا تتفرّع نسختان قد تختلفان.
import { PlansList } from '../subscriptions/components/plans/PlansList.jsx';

export function PricingScreen() {
  const [tab, setTab] = useState('rules');

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-xl font-extrabold tracking-tight m-0">إعدادات التسعير</h2>
          <div className="text-ink-3 text-xs mt-0.5">
            القواعد، الباقات، الخصومات، الاشتراكات الشهرية، ومحاكي الأسعار
          </div>
        </div>
        <PricingTabs value={tab} onChange={setTab} />
      </div>

      {tab === 'rules' ? <RulesList /> : null}
      {tab === 'packages' ? <PackagesList /> : null}
      {tab === 'discounts' ? <DiscountsList /> : null}
      {tab === 'subscriptions' ? <PlansList /> : null}
      {tab === 'simulator' ? <Simulator /> : null}
    </div>
  );
}
